














































































































































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { ICompany, IParticipation, ITenant, IPlan, ILayoutRules } from '@/types/types'
import { updateCompany } from '@/services/company'

interface IPlanWithType extends IPlan {
  type: string
}

@Component({
  components: {},
})
export default class CardSelectTenant extends Vue {
  @Prop({ default: {} }) company: ICompany
  @Prop({ default: {} }) participation: IParticipation
  @Prop({}) tenant: ITenant

  layoutRulesLabels = [
    {
      action: 'login-redirect',
      label: 'Login',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'home',
      label: 'Perfil',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'climate',
      label: 'Engajamento: Clima',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'culture',
      label: 'Engajamento: Cultura',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'participation',
      label: 'Engajamento: Participação',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'groups-comparison',
      label: 'Engajamento: Comparação de Grupos',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'benchmark',
      label: 'Engajamento: Benchmark',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'opinions',
      label: 'Engajamento: Opiniões',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'action-plans',
      label: 'Engajamento: Plano de Ação',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'survey',
      label: 'Engajamento: Pesquisa',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'engagement-summary',
      label: 'Engajamento: Resumo Semanal',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'management-groups',
      label: 'Configurações: Grupos',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
    {
      action: 'management-people',
      label: 'Configurações: Pessoas',
      isLegacy: {
        admin: true,
        manager: true,
        user: true,
      }
    },
  ]

  layoutRules: ILayoutRules = {
    admin: {
      'login-redirect': 'legacy',
      'home': 'legacy',
      'climate': 'legacy',
      'culture': 'legacy',
      'participation': 'legacy',
      'groups-comparison': 'legacy',
      'benchmark': 'legacy',
      'opinions': 'legacy',
      'action-plans': 'legacy',
      'survey': 'legacy',
      'engagement-summary': 'legacy',
      'management-groups': 'legacy',
      'management-people': 'legacy',
    },
    manager: {
      'login-redirect': 'legacy',
      'home': 'legacy',
      'climate': 'legacy',
      'culture': 'legacy',
      'participation': 'legacy',
      'groups-comparison': 'legacy',
      'benchmark': 'legacy',
      'opinions': 'legacy',
      'action-plans': 'legacy',
      'survey': 'legacy',
      'engagement-summary': 'legacy',
      'management-groups': 'legacy',
      'management-people': 'legacy',
    },
    user: {
      'login-redirect': 'legacy',
      'home': 'legacy',
      'climate': 'legacy',
      'culture': 'legacy',
      'participation': 'legacy',
      'groups-comparison': 'legacy',
      'benchmark': 'legacy',
      'opinions': 'legacy',
      'action-plans': 'legacy',
      'survey': 'legacy',
      'engagement-summary': 'legacy',
      'management-groups': 'legacy',
      'management-people': 'legacy',
    },
  }

  hasSlackIntegration = false
  isDeactivated = true
  hasCulture = false
  hasClimate = false
  hasCustomSurvey = false
  hasPerformance = false
  hasGrowth = false
  isOpen = true
  isEdit = false
  loadingEdit = false

  companyPlan: IPlanWithType

  internalCompany: ICompany

  availablePlan = [
    {
      id: 'free',
      name: 'Gratuito',
    },
    {
      id: 'trial',
      name: 'Período de Avaliação',
    },
    {
      id: 'basic',
      name: 'Básico',
    },
    {
      id: 'advanced',
      name: 'Avançado',
    },
    {
      id: 'enterprise',
      name: 'Empresarial',
    }
  ]

  type = {
    free: 'is-info',
    trial: 'is-warning',
    basic: 'is-primary',
    advanced: 'is-link',
    enterprise: 'is-success',
  }


  @Watch('company', { immediate: true })
  onCompanyChange(company: ICompany) {
    this.internalCompany = { ...company }
    this.isDeactivated = company.deactivated
    this.hasClimate = company.modules.engagement || false
    this.hasCulture = company.modules.culture || false
    this.hasCustomSurvey = company.modules.customSurvey || false
    this.hasPerformance = company.modules.performance || false
    this.hasGrowth = company.modules.growth || false
    this.isEdit = false

    this.hasSlackIntegration =
      company.hasOwnProperty('integrations') &&
      company.integrations.hasOwnProperty('slackWorkspaces') &&
      company.integrations.slackWorkspaces.length > 0

    if (!this.internalCompany.plan) {
      this.internalCompany.plan = this.internalCompany.billing.plan.id === 'basic'
        ? { id: 'free', name: 'Gratuito' }
        : this.internalCompany.billing.plan
    }

    this.updatePlan(this.internalCompany.plan)

    if (company.hasOwnProperty('layoutRules') && company.layoutRules) {
      // admin
      this.layoutRules.admin = {
        ...this.layoutRules.admin,
        ...company.layoutRules.admin,
      }

      // manager
      this.layoutRules.manager = {
        ...this.layoutRules.manager,
        ...company.layoutRules.manager,
      }

      // user
      this.layoutRules.user = {
        ...this.layoutRules.user,
        ...company.layoutRules.user,
      }

      for (const layoutRule of this.layoutRulesLabels) {
        const { action } = layoutRule

        layoutRule.isLegacy.admin = this.layoutRules.admin[action] === 'legacy'
        layoutRule.isLegacy.manager = this.layoutRules.manager[action] === 'legacy'
        layoutRule.isLegacy.user = this.layoutRules.user[action] === 'legacy'
      }
    }
  }

  @Emit('sendInvites')
  sendInvites() {
    return true
  }

  @Emit('afterCompanyEdit')
  async saveCompany() {
    try {
      if (!this.tenant.tenantName) {
        return false
      }

      // const plan = this.availablePlan.find(p => p.id === this.internalCompany.billing.plan.id)
      this.internalCompany.deactivated = this.isDeactivated

      if (this.internalCompany.billing.expiresAtObj) {
        this.internalCompany.billing.expiresAt = JSON.parse(JSON.stringify(this.internalCompany.billing.expiresAtObj))
      }

      this.internalCompany.modules = {
        engagement: this.hasClimate,
        climate: this.hasClimate,
        culture: this.hasCulture,
        customSurvey: this.hasCustomSurvey,
        performance: this.hasPerformance,
        growth: this.hasGrowth
      }

      this.internalCompany.billing.plan = this.internalCompany.plan


      for (const layoutRule of this.layoutRulesLabels) {
        const { action } = layoutRule

        this.layoutRules.admin[action] = layoutRule.isLegacy.admin ? 'legacy' : 'new-layout'
        this.layoutRules.manager[action] = layoutRule.isLegacy.manager ? 'legacy' : 'new-layout'
        this.layoutRules.user[action] = layoutRule.isLegacy.user ? 'legacy' : 'new-layout'
      }

      this.internalCompany.layoutRules = this.layoutRules

      this.loadingEdit = true
      await updateCompany(this.tenant.tenantName, this.internalCompany)

      this.updatePlan(this.internalCompany.plan)

      this.isEdit = false
    } catch (error) {
      // console.log(error)
      this.$buefy.toast.open({
        message: 'Falha ao atualizar os dados dessa conta',
        type: 'is-danger'
      })
    } finally {
      this.loadingEdit = false
    }
  }

  toggleIsEdit() {
    this.isEdit = !this.isEdit
  }

  updatePlan(plan: IPlan) {
    this.companyPlan = {
      ...plan,
      type: this.type[plan.id]
    }
  }
}
